import * as types from './constants';

const initialState = {
  // Which product is being expanded, so only that row shows a spinner.
  loading_product_id: null,
  errors_api: {}
};

const actions = {
  // Get Shopify Product Variants
  [types.GET_SHOPIFY_PRODUCT_VARIANTS_REQUEST]: (state, { payload }) => {
    const data = {
      ...state,
      loading_product_id: payload.productId,
      errors_api: {}
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_PRODUCT_VARIANTS_DONE]: state => {
    const data = {
      ...state,
      loading_product_id: null
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_PRODUCT_VARIANTS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading_product_id: null,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_PRODUCT_VARIANTS_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
